// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__noTPM","title":"Info_title__216qw","selects":"Info_selects__1wqU2","requiredAsterisk":"Info_requiredAsterisk__2WZZZ"};